import React from 'react'

export default function Services() {
  return (

    <section id="services" className="services">
      <div className="container">

        <div className="section-title">
          <h2>Services</h2>
          <p>My Services</p>
        </div>

        <div className="row">
          <div className="col-lg-4 col-md-6 d-flex align-items-stretch">
            <div className="icon-box">
              <div className="icon"><i className="bx bx-globe"></i></div>
              <h4>Web Development</h4>
              <p>Attractive and easy-to-use websites that serve corporate, e-commerce, non-profit, and personal purposes –
                that’s what I am highly skilled in designing and developing. Is that what you want?</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-md-0">
            <div className="icon-box">
              <div className="icon"><i className="bx bx-mobile"></i></div>
              <h4>Mobile Development</h4>
              <p>From the look and feel to the ease of navigation, I build mobile applications that are tailored to take
                you closer to your target market, and help you build profitable relationships with your customers. Does
                your business need one?</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-lg-0">
            <div className="icon-box">
              <div className="icon"><i className="bx bx-cloud"></i></div>
              <h4>Cloud Computing</h4>
              <p>Cloud computing allows you to cut your operational and fixed monthly costs of hardware,
                databases, servers, software licenses. Eventually, it will reduce the need for IT resources, including
                people.</p>
            </div>
          </div>
        </div>

      </div>
    </section>
  )
}
